import React, { useState } from 'react';

import { Grid, Typography, TextField } from '@mui/material';
import { greyOutEmptyTextField } from '../../Helpers/helpers';

const ICLRunningWarm = (props) => {
  const handleChange = props.handleChange;

  const [binFan, set_binFan] = useState(props.data.binFan);
  const [condensorDirty, set_condensorDirty] = useState(
    props.data.condensorDirty
  );
  const [pressureLow, set_pressureLow] = useState(props.data.pressureLow);

  const handleElementChange = (val, item) => {
    switch (item) {
      case 'binFan':
        set_binFan(val);
        break;
      case 'condensorDirty':
        set_condensorDirty(val);
        break;
      case 'pressureLow':
        set_pressureLow(val);
        break;

      default:
        break;
    }
    handleChange(val, item);
  };

  return (
    <Grid
      container
      rowSpacing={0}
      margin={0}
      columnSpacing={{ xs: 0 }}
      rowGap={0}
      style={{ marginLeft: 0, marginRight: 0 }}
    >
      <Grid sx={{ border: 'none' }} item xs={12} md={12}>
        <Typography variant='h6' fontWeight='700' fontSize={18}>
          Running Warm
        </Typography>
      </Grid>
      <Grid
        sx={{ border: 'solid black 1px', borderBottom: 'none' }}
        item
        xs={4}
        md={4}
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='center'
        >
          Check bin fans
        </Typography>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          borderLeft: 'none',
          background: greyOutEmptyTextField(binFan)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          fullWidth
          id='binFan'
          sx={{ '& fieldset': { border: 'none' } }}
          size='small'
          value={binFan}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
        ></TextField>
      </Grid>
      <Grid
        sx={{ border: 'solid black 1px', borderBottom: 'none' }}
        item
        xs={4}
        md={4}
      >
        <Typography paddingLeft={1}>Check if condenser is dirty</Typography>
      </Grid>
      <Grid
        sx={{
          border: 'solid black 1px',
          borderBottom: 'none',
          borderLeft: 'none',
          background: greyOutEmptyTextField(condensorDirty)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='condensorDirty'
          fullWidth
          sx={{ '& fieldset': { border: 'none' } }}
          size='small'
          value={condensorDirty}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
        ></TextField>
      </Grid>
      <Grid sx={{ border: 'solid black 1px' }} item xs={4} md={4}>
        <Typography paddingLeft={1}>
          Check gas pressure and for gas leak if pressure is low
        </Typography>
      </Grid>
      <Grid
        sx={{ border: 'solid black 1px', borderLeft: 'none', background: greyOutEmptyTextField(pressureLow) }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='pressureLow'
          fullWidth
          size='small'
          sx={{ '& fieldset': { border: 'none' } }}
          value={pressureLow}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
        ></TextField>
      </Grid>
    </Grid>
  );
};

export default ICLRunningWarm;
